import {
  getMuscleUsageMapExerciseUtil,
  MUSCLE_MESSAGE
} from '@gymaholic/packages'
import MusclesAnatomy from 'components/MusclesAnatomy'
import Text from 'components/Text'
import formatMessageIntlUtil from 'modules/intl/utils/format-message'
import React from 'react'
import { defineMessages } from 'react-intl'
import useIntl from 'modules/component/utils/hooks/useIntl'
import Collapsible from 'components/Collapsible/index.js'

const messages = defineMessages({
  exerciseAlsoTrains: {
    id: 'ExerciseContentMuscles.exerciseAlsoTrains',
    defaultMessage: '{exerciseNamePlural} also train these muscles:'
  }
})

/**
 * @param {ExerciseContentProps} props
 * @return {Element}
 * @constructor
 */
export default function ExerciseContentMuscles ({
  whatMuscles,
  musclesWorkedStr,
  forceStr,
  secondaryMuscles,
  exercise,
  exerciseNamePlural
}) {
  const intl = useIntl()

  return (
    <Collapsible
      label={whatMuscles}
      isOpen
    >
      <Text
        mb
      >
        {musclesWorkedStr}
      </Text>
      <Text
        mb
      >
        {forceStr}
      </Text>

      {
        secondaryMuscles &&
        secondaryMuscles.length > 0 && (
          <>
            <Text>
              {
                formatMessageIntlUtil(
                  intl,
                  messages.exerciseAlsoTrains,
                  { exerciseNamePlural }
                )
              }
            </Text>
            <ul
              style={{
                paddingLeft: '1.5rem',
                margin: 0,
                marginTop: '10px'
              }}
            >
              {
                secondaryMuscles.map((muscle, index) => (
                  <li key={index}>{formatMessageIntlUtil(intl, MUSCLE_MESSAGE[muscle])}</li>
                ))
              }
            </ul>
          </>
        )
      }

      <MusclesAnatomy
        musclesUsageMap={getMuscleUsageMapExerciseUtil(exercise)}
        height={150}
      />
    </Collapsible>
  )
}
